import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
//import TagManager from 'react-gtm-module';

import './index.css';
import App from './App';
import '../node_modules/intl-tel-input/build/css/intlTelInput.css';
// import registerServiceWorker from './registerServiceWorker';
import reducer from './store/reducers/reducer';


const store = createStore(reducer, applyMiddleware(thunk));

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// TagManager.initialize({
//   gtmId: "GTM-NLN8MKLM"
// });

ReactDOM.render(app, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js